
import { Utilidades } from "@/Util/Utilidades";
import {
  FicheroDatos,
} from "@/model/Fichero";
import { FicheroService } from "@/services/FicheroService";
import Vue from "vue";
import { Constantes } from "@/Util/Constantes";

export default Vue.extend({
  name: "verFichero",
  props: {
    id_fichero: {
      default: "",
      type: String,
    },
    titulo: {
      default: "Fichero",
      type: String,
    },
    tooltip: {
      default: "Ver Fichero",
      type: String,
    },
    icono: {
      default: "mdi-card-search-outline",
      type: String,
    },
    color: {
      default: "primary",
      type: String,
    },
  },
  data() {
    return {
      fichero: new Object() as FicheroDatos,
      controleFicheros: new Array<FicheroDatos>(),
      loading: false as boolean,
      dialog: false as boolean,
      nombre_fichero: ""
    };
  },
  watch: {
    dialog: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.controleFicheros = new Array<FicheroDatos>();
          this.nombre_fichero = '';
          this.verFichero();
        }
      },
    },
  },
  async mounted() {},
  methods: {
    cerrarDialog() {
      this.fichero = new Object() as FicheroDatos;
      this.dialog = false;        
    },
    async verFichero() {
      this.loading = false;
      this.fichero.id_fichero = this.id_fichero;

      if(!Utilidades.isNullOrUndefinedOrEmpty(this.fichero.id_fichero)){

        this.loading = true;
        await FicheroService.downloadFicheroAsync(this.fichero.id_fichero)
          .then((response) => {
            //this.fichero.base64 = response.data.datos;
            this.controleFicheros = new Array<FicheroDatos>();
            let item = new Object() as FicheroDatos;
            item.base64 = response.data.datos;
            item.nombre_fichero = response.data.nombre;
            this.nombre_fichero = item.nombre_fichero;
            item.mime = item.base64.split(";")[0].replace("data:", "");
            item = this.getTipoFichero(item);
            this.controleFicheros.push(item);
          })
          .catch((x) => {         
            this.cerrarDialog();
            Utilidades.Message({
              message: x.response.data,
              error: true,
            });
            
          })
          .finally(() => {
            this.loading = false;
          });
      }else{
        Utilidades.Message({
          message: "No se ha informado el fichero.",
          error: true,
        });          
        
        this.cerrarDialog();
      }
      this.loading = false;
      
    },
    cerrarModalFichero() {
      this.dialog = false;
    },
    getTipoFichero(fichero: FicheroDatos): FicheroDatos {
      var index = fichero.nombre_fichero.split(".");
      var extension = fichero.nombre_fichero.split(".")[index.length - 1];

      switch (extension?.trim()) {
        case "png":
        case "gif":
        case "jpeg":
        case "jpg":
        case "webp":
          fichero.tipo = "image";
          break;
        case "pdf":
          fichero.tipo = "pdf";
          break;
        case "doc":
        case "docx":
          fichero.tipo = "word";
          fichero.icono_tipo = "mdi-file-word-outline";
          fichero.color_icono = "blue";
          break;
        case "xls":
        case "xlsx":
          fichero.tipo = "excel";
          fichero.icono_tipo = "mdi-file-excel-outline";
          fichero.color_icono = "green";
          break;
        case "ppt":
        case "pptx":
          fichero.tipo = "powerpoint";
          fichero.icono_tipo = "mdi-file-powerpoint-outline";
          fichero.color_icono = "red";
          break;
        case "xml":
          fichero.tipo = "xml";
          fichero.icono_tipo = "mdi-xml";
          fichero.color_icono = "primary";
          break;
        default:
          fichero.tipo = "otro";
          fichero.icono_tipo = "mdi-file-outline";
          fichero.color_icono = "primary";
          break;
      }

      return fichero;
    },
  },
});
